import styled from 'styled-components'
import { screen } from '../../styles/mq'

export const HeaderContainer = styled.header`
  position: relative;
  width: 100%;
  height: 60px;
  background: var(--dark);
  display: flex;
  justify-content: end;
  align-items: center;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid var(--main);
  a {
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.5s;
    height: 100%;
    padding: 0 24px;
    font-weight: 700;
    color: var(--light);
    &:hover {
      background: var(--second);
    }
  }
  .menu-desktop-item {
    @media (max-width: ${screen.s}) {
      display: flex;
    }
  }
  button {
    display: none;
    height: 100%;
    padding: 0 24px;
    background: transparent;
    border: none;
    border-radius: 0;
    cursor: pointer;
    transition: all 0.5s;
    &:hover {
      background: var(--second);
    }
    @media (max-width: ${screen.s}) {
      display: flex;
      padding: 0 12px 2px 16px;
    }
    svg {
      width: 20px;
      fill: var(--dark);
      stroke: var(--light);
    }
  }
`

export const MenuDesktop = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 100%;
  @media (max-width: ${screen.s}) {
    display: none;
  }
`

export const MenuMobile = styled.div<{ $active: boolean }>`
  display: none;
  position: absolute;
  top: 0;
  right: 0px;
  padding-right: 36px;
  transform: translateX(${props => (props.$active ? '0%' : '100%')});
  background: var(--dark);
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
  transition: all 0.5s;
  @media (max-width: ${screen.s}) {
    display: block;
  }
  a {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  z-index: 100;
`
export const MenuClose = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  button {
    font-size: 20px;
    padding: 8px;
  }
`
export const MenuLanguage = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.5s;
  height: 100%;
  padding: 0 24px;
  font-weight: 700;
  cursor: pointer;
  span {
    color: var(--light);
  }
  @media (max-width: ${screen.s}) {
    padding: 0 16px 0 12px;
  }
`
